import { useContext, useEffect, useState } from "react";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import { useGetFuelCostSummaryQuery } from "../../../../../Redux/service/DriversTraccar/DriversTraccar";
import trans, { convertMillisecondsToTime, isRTL } from "../../../../../utils";
import AntdTable from "../../../../antd/Table/Table";
import {
  DistanceUnit,
  VolumeUniit,
} from "../../../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";

export default function TotalFuelTable({ limit, query, setLimit, setQuery }) {
  const { setSort: SetSortFilter } = useContext(filtrationcontext);
  const [currentPage, setCurrentPage] = useState(1);
  const inf = useSelector((state) => state.users.user);

  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  const now = new Date();
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const endOfMonth = new Date(
    now.getFullYear(),
    now.getMonth() + 1,
    0,
    23,
    59,
    59
  );

  const from = startOfMonth.toISOString(); // Start of month
  const to = endOfMonth.toISOString(); // End of month

  const { data, isLoading, isError } = useGetFuelCostSummaryQuery(
    {
      from,
      to,
      page: currentPage,
      pageSize: limit,
      sortBy: sort.by,
      sortOrder: sort.order,
      search: query,
    },
    {
      skip: !currentPage || !limit,
    }
  );

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "id", value: null });
      setLimit(10);
      setQuery("");
      localStorage.setItem("page", 1);
    };
  }, [setLimit, SetSortFilter, setQuery]);

  const columns = [
    {
      title: trans("Name"),
      dataIndex: "name",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      sorter: true,
      render: (value) => (
        <span className={"table-element-name ps-0"}>{value}</span>
      ),
    },
    {
      title: trans("Group"),
      dataIndex: "groupName",
      width: 150,
      sorter: true,
      render: (value) => value || "Ungrouped Vehicles",
    },
    {
      title: trans("Fuel Cost"),
      dataIndex: "fuelCost",
      width: 150,
      sorter: true,
      render: (value) => `${value.toFixed(2)} ${trans("AED")}` || "- - - - -",
    },
    {
      title: trans("Fuel Price"),
      dataIndex: "fuelPrice",
      width: 150,
      sorter: true,
      render: (value) => `${value.toFixed(2)} ${trans("AED")}` || "- - - - -",
    },
    {
      title: trans("Spent Fuel"),
      dataIndex: "spentFuel",
      width: 150,
      sorter: true,
      render: (value) =>
        VolumeUniit(value, inf?.attributes?.volumeUnit || "ltr"),
    },

    {
      title: trans("Engine Hours"),
      dataIndex: "engineHours",
      width: 150,
      sorter: true,
      render: (value) =>
        value ? convertMillisecondsToTime(value) : "- - - - -",
    },

    {
      title: trans("Total Distance"),
      dataIndex: "totalDistance",
      width: 150,
      sorter: true,
      render: (value) =>
        DistanceUnit(value, inf?.attributes?.distanceUnit || "km"),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="mt-3 table-parent">
      <AntdTable
        columns={columns}
        dataSource={data?.data || []}
        loading={isLoading}
        pageSize={limit}
        totalItems={data?.totalCount}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={300}
      />
    </div>
  );
}
